const APP_PREFIX = 'rpnd-'

export default new class SessionStorage {

  GRID_QUERY       = 'grid-query'
  GRID_LAST_ROW    = 'grid-last-row'
  GRID_SUCCESS_ROW = 'grid-success-row'

  /**
   *
   * @param key
   * @param nullReturn
   * @return {string}
   */
  getItem (key, nullReturn = null) {
    let data = sessionStorage.getItem(APP_PREFIX + key)
    if (!data) {
      return nullReturn
    }
    return JSON.parse(data)
  }

  /**
   *
   * @param key
   * @param data
   */
  setItem (key, data) {
    data = JSON.stringify(data)
    return sessionStorage.setItem(APP_PREFIX + key, data)
  }

  /**
   *
   * @param namespace
   * @param key
   * @return {string}
   */
  getArrayItem (namespace, key) {
    let data = this.getItem(namespace)

    if (!data) {
      return null
    }

    for (let i = 0; i < data.length; i++) {
      if (data[i].key === (key)) {
        return data[i]
      }
    }
  }

  /**
   *
   * @param namespace
   * @param data
   */
  setArrayItem (namespace, data) {
    let universe = this.getItem(namespace)

    if (!universe) {
      this.setItem(namespace, [data])
      return
    }

    for (let i = 0; i < universe.length; i++) {
      if (universe[i].key === data.key) {
        universe[i] = data
        this.setItem(namespace, universe)
        return
      }
    }

    universe.push(data)
    this.setItem(namespace, universe)
  }

  /**
   *
   * @param namespace
   * @param key
   */
  clearArray (namespace, key) {
    let universe = this.getItem(namespace, [])

    for (let i = 0; i < universe.length; i++) {
      if (universe[i].key === key) {
        universe.splice(i, 1)
        this.setItem(namespace, universe)
        return
      }
    }
  }
}
